console.log('slides:', document.querySelectorAll('.mv .swiper-slide').length);

$(document).ready(function(){
  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 60
        }, 1000);
      }
    }
  });
});

// const swiper = new Swiper('.swiper', {
//   slidesPerView: 1,
//   loop: true,
//   // autoplay: {
//   //   delay: 4000,
//   //   disableOnInteraction: false
//   // },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   }
// });

const swiper = new Swiper('.mv .swiper', {
  slidesPerView: 1,
  loop: true,
  speed: 600,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  // on: {
  //   init() {
  //     handleVideos(this)
  //   },
  //   slideChangeTransitionStart() {
  //     stopAllVideos()
  //   },
  //   slideChangeTransitionEnd() {
  //     handleVideos(this)
  //   }
  // }
})

// function stopAllVideos() {
//   document.querySelectorAll('.slide-video').forEach(video => {
//     video.pause()
//     video.currentTime = 0
//   })
// }

// function handleVideos(swiper) {
//   const activeSlide = swiper.slides[swiper.activeIndex]
//   const videos = activeSlide.querySelectorAll('.slide-video')

//   if (!videos.length) {
//     swiper.autoplay.start()
//     return
//   }

//   swiper.autoplay.stop()

//   let endedCount = 0

//   videos.forEach(video => {
//     video.play().catch(() => {})

//     video.onended = () => {
//       endedCount++
//       if (endedCount === videos.length) {
//         swiper.slideNext()
//         swiper.autoplay.start()
//       }
//     }
//   })
// }

document.addEventListener('DOMContentLoaded', () => {
  const mv = document.querySelector('.mv');
  const fixedCv = document.querySelector('.cv__fixed');
  const footer = document.querySelector('.footer');

  if (!mv || !fixedCv || !footer) return;

  let isPastMv = false;
  let isFooterVisible = false;

  const updateState = () => {
    if (isPastMv && !isFooterVisible) {
      fixedCv.classList.add('open');
    } else {
      fixedCv.classList.remove('open');
    }
  };

  const mvObserver = new IntersectionObserver(
    ([entry]) => {
      isPastMv = !entry.isIntersecting;
      updateState();
    },
    {
      root: null,
      threshold: 0
    }
  );

  const footerObserver = new IntersectionObserver(
    ([entry]) => {
      isFooterVisible = entry.isIntersecting;
      updateState();
    },
    {
      root: null,
      threshold: 0.01
    }
  );

  mvObserver.observe(mv);
  footerObserver.observe(footer);
});

$('.nav a').on('click', function () {
  $('#js-check').prop('checked', false);
});